var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ConfirmToolbar } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import Loading from '../common/Loading';
import { getLegalTypeOptions, mapLegalTypeOptions, jurisdictionOptions, } from './helpers';
import regEx from '../../utils/regex';
import { List, ListItemInput, ListItemSelect, ListItemTextArea, } from '@bootstraplabs/bsw-common-react';
import { useOrganizationDetailsQuery, useUpdateOrganizationMutation, JurisdictionOfFormation as Jurisdiction, LegalType, } from '../../__generated__/graphql';
export default function EditOrganization(props) {
    // State
    var _a = useState(''), name = _a[0], setName = _a[1];
    var _b = useState(''), description = _b[0], setDescription = _b[1];
    var _c = useState(Jurisdiction.US_DE), jurisdiction = _c[0], setJurisdiction = _c[1];
    var _d = useState(LegalType.INC), legalType = _d[0], setLegalType = _d[1];
    // Helpers
    var legalTypeOptions = mapLegalTypeOptions(jurisdiction);
    var organizationId = (props.match && props.match.params.organizationId) || '';
    // GraphQL mutation
    var createOrganization = useUpdateOrganizationMutation({
        variables: {
            input: {
                organizationId: organizationId,
                jurisdictionOfFormation: jurisdiction,
                legalType: legalType,
                name: name.trim(),
                description: description.trim(),
            },
        },
    })[0];
    var updateJurisdiction = function (j) {
        var ltOptions = getLegalTypeOptions(j);
        var legalTypeAllowed = Reflect.has(ltOptions, legalType);
        if (!legalTypeAllowed) {
            setLegalType(LegalType.INC);
        }
        setJurisdiction(j);
    };
    // GraphQL query
    var _e = useOrganizationDetailsQuery({
        variables: { organizationId: organizationId },
    }), data = _e.data, loading = _e.loading;
    var organization = data && data.organization;
    useEffect(function () {
        if (organization) {
            setName(organization.name);
            setDescription(organization.description);
            setJurisdiction(organization.jurisdictionOfFormation);
            setLegalType(organization.legalType);
        }
    }, [organization]);
    if (loading) {
        return _jsx(Loading, {}, void 0);
    }
    if (!organization) {
        throw new Error('Organization does not exist');
    }
    return (_jsxs(_Fragment, { children: [_jsx(ConfirmToolbar, __assign({ disabled: !name ||
                    (name && regEx.trimmedString.test(name.trim())) === false ||
                    name.trim().length < 1 ||
                    name.trim().length > 100 ||
                    !description ||
                    description.trim().length > 1000 ||
                    // Note: The textInput will only accept 1000 characters and cut the text after 1000 char.
                    // Consequently the disable function will not be utilized as long as
                    // a supported browser is used, and the HTMLInputElement is displayed as expected.
                    description.trim().length < 1 ||
                    !legalType ||
                    !jurisdiction, onClick: createOrganization }, { children: "Edit Company" }), void 0),
            _jsx(Body, { children: _jsxs(List, { children: [_jsx(ListItemInput, { labelWidth: 200, type: "text", label: "Name", value: name, onChange: setName }, void 0),
                        _jsx(ListItemTextArea, { label: "Description", value: description, onChange: setDescription }, void 0),
                        _jsx(ListItemSelect, { labelWidth: 200, label: "Jurisdiction of formation", value: jurisdiction, onChange: function (val) { return updateJurisdiction(val); }, options: jurisdictionOptions }, void 0),
                        _jsx(ListItemSelect, { labelWidth: 200, label: "Legal type", value: legalType, onChange: function (val) { return setLegalType(val); }, options: legalTypeOptions }, void 0)] }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=EditOrganization.js.map